import Vue from 'vue'

let pending = 0

const manager = Vue.observable({
  isLoading: false,
  error: null
})
Object.assign(manager, {startLoading, endLoading, withLoading})

export default {
  install (Vue) {
    Vue.prototype.$loading = manager
  }
}

export function withLoading (fn, context = null) {
  return (...args) => {
    startLoading()

    if (args.length === fn.length - 1) return fn.call(context, ...args, endLoading)

    const resolved = fn.call(context, ...args)
    Promise.resolve(resolved).then(() => endLoading(null), err => endLoading(err))
    return resolved
  }
}

export function startLoading () {
  ++pending
  manager.isLoading = true
}

export function endLoading (err) {
  --pending
  if (pending === 0) manager.isLoading = false
  if (err) throw err
}
